import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children, roles }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center bg-background" data-testid="auth-loading">
        <div className="label-caps">Loading Project Hub</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.status && user.status !== "active") return <Navigate to="/pending-approval" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};
